class DistillerFilter extends HTMLElement {
  connectedCallback() {
    this.pills = this.querySelectorAll('[data-filter]');
    this.grid  = document.querySelector('.distillers-list-mab__grid');
    this.pills.forEach(p => p.addEventListener('click', () => this.#apply(p)));
    this.#sortAlpha();
  }

  #apply(activePill) {
    const filter = activePill.dataset.filter;
    this.pills.forEach(p => p.classList.toggle('is-active', p === activePill));
    for (const card of this.grid.querySelectorAll('[data-types]')) {
      const types = card.dataset.types || '';
      const match = filter === 'all' || types.split(',').includes(filter);
      card.classList.toggle('is-hidden', !match);
    }
  }

  #sortAlpha() {
    const cards = [...this.grid.querySelectorAll('[data-name]')];
    cards.sort((a, b) => a.dataset.name.localeCompare(b.dataset.name));
    cards.forEach(c => this.grid.appendChild(c));
  }
}

customElements.define('distiller-filter-mab', DistillerFilter);
